export default "__VITE_ASSET__bdfed05c__"